/**
 * Frontend allow-list: only these menu items are shown across the dashboard.
 * Matching is case-insensitive; extra spaces are ignored.
 */
import { isComboAggregateItem, normalizeItemKey } from './comboAggregate';

const ALLOWED_ITEM_NAMES = [
  'non veg combo 1',
  'non veg combo 2',
  'non veg lunch',
  'non veg combo 1 + combo 2',
  'veg lunch',
];

const ALLOWED_SET = new Set(ALLOWED_ITEM_NAMES);

function normalizeItemName(itemname) {
  return normalizeItemKey(itemname);
}

export function isAllowedItem(itemname) {
  const name = normalizeItemName(itemname);
  if (!name) return false;
  if (ALLOWED_SET.has(name)) return true;
  if (isComboAggregateItem(itemname)) return true;
  const compact = name.replace(/\s+/g, '');
  return (
    compact === 'nonvegcombo1' ||
    compact === 'nonvegcombo2' ||
    compact === 'nonvegcombo1+combo2' ||
    compact === 'nonvegcombo1combo2' ||
    compact === 'nonveglunch' ||
    compact === 'veglunch'
  );
}

export function filterAllowedItems(rows) {
  if (!rows || rows.length === 0) return rows || [];
  return rows.filter((row) => isAllowedItem(row.itemname));
}
